import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import AccountDetailsBL from '../../../financial-stories/AccountDetailsNew/AccountDetailsBL';
import StringConstant from '../../../../constants/StringConstants';
import { map, find } from 'lodash';

const AccountDropDown = ({
  selectedAccountId,
  onDropdownSelect,
  accountList,
  hasAll,
}) => {
  const displaySelectedAccount = () => {
    const selectedAccount = find(
      accountList,
      (account) => account.id === selectedAccountId
    );
    if (selectedAccount) {
      const accountNumber =
        AccountDetailsBL.getAccountDisplayNumber(selectedAccount);
      return (
        <span
          className="btn--title btn--title--multiline"
          aria-labelledby="account-name account-number"
        >
          <span className="account-name" id="account-name">
            {selectedAccount.displayName}
          </span>
          <span className="account-number" id="account-number">
            <span className="u-visually-hidden off-screen">
              Account Sort Code and Account Number
            </span>
            {accountNumber}
          </span>
        </span>
      );
    }
    return (
      <span
        className="btn--title btn--title--multiline"
        aria-labelledby="account-name"
      >
        <span className="account-name" id="account-name">
          {selectedAccountId}
        </span>
      </span>
    );
  };

  const displayAccountsMenu = () => {
    const accountsMenu = [];
    map(accountList, (account) => {
      const accountNumber = AccountDetailsBL.getAccountDisplayNumber(account);
      const accountDropDown = (
        <MenuItem eventKey={account.id} onSelect={onDropdownSelect}>
          <span className="account-name" aria-label="Account Name">
            {account.displayName}
          </span>
          <span className="account-number">
            <span className="u-visually-hidden off-screen">
              Account Sort Code and Account Number
            </span>
            {accountNumber}
          </span>
        </MenuItem>
      );
      accountsMenu.push(accountDropDown);
    });
    if (hasAll) {
      accountsMenu.push(
        <MenuItem
          eventKey={StringConstant.ALL_ACCOUNTS}
          onSelect={onDropdownSelect}
        >
          <span className="account-name" aria-labelledby="All Accounts">
            {StringConstant.ALL_ACCOUNTS}
          </span>
        </MenuItem>
      );
    }
    return accountsMenu;
  };

  return (
    <div
      className="btn-toolbar c-payment-history_account-dropdown"
      aria-labelledby="dropdown-account-select-menu"
    >
      <Dropdown className="custom-dropdown">
        <Dropdown.Toggle
          noCaret
          className="custom-dropdown__btn accountDropdown_btn"
          id="selected-account"
        >
          {displaySelectedAccount()}
          <span className="symbol">
            <svg width="32" height="61" viewBox="0 0 32 32" role="img">
              <path d="M19.55 12.602l1.884 1.833-5.717 5.565-5.717-5.565 1.883-1.833 3.833 3.731z" />
            </svg>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdowm-menu--scroll dropdowm-menu--z-index">
          {displayAccountsMenu()}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

AccountDropDown.propTypes = {
  selectedAccountId: PropTypes.string.isRequired,
  onDropdownSelect: PropTypes.func.isRequired,
  accountList: PropTypes.array.isRequired,
  hasAll: PropTypes.bool,
};

export default AccountDropDown;
